import { gsap } from 'gsap';
function Animate(sprite, { duration = 1, speed = 1, ease = 'Cubic.easeIn', delayValue, index, SpriteFinalX }) {
  var x = SpriteFinalX;
  var finalX = x + 60;
  var animation = gsap.to(sprite, {
    pixi: { x: finalX, alpha: 0 },
    duration: duration * speed,
    delay: delayValue,
    ease: 'slow(0.3, 0.7, false)',
    paused: true,
  });
  return animation;
}
export default { Animate };
